<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="姓名：">
        <el-input v-model="query.name" placeholder="请输入姓名" clearable size="small" />
      </el-form-item>
      <el-form-item label="手机号：">
        <el-input v-model="query.pho" placeholder="请输入手机号" clearable size="small" />
      </el-form-item>
      <el-form-item label="是否使用：">
        <el-select v-model="query.isUse" placeholder="请选择" clearable size="small">
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间范围：" required>
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import customerRegistrationApi from '@/api/cust/customerRegistration'
import { filterEmpty } from '@/utils'
export default {
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        name: undefined,
        pho: undefined,
        isUse: undefined,
        pageNo:1,
        pageSize:1000

      },
    }
  },
  created() {
    // 设置默认时间为当前月
    const now = new Date()
    const year = now.getFullYear()
    const month = now.getMonth()
    // 当前月的第一天 00:00:00
    const startDate = new Date(year, month, 1)
    const startTime = this.formatDateTime(startDate)
    // 当前月的最后一天 23:59:59
    const endDate = new Date(year, month + 1, 0, 23, 59, 59)
    const endTime = this.formatDateTime(endDate)
    this.dateTime = [startTime, endTime]
  },
  methods: {
    // 格式化日期时间为 yyyy-MM-dd HH:mm:ss
    formatDateTime(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    handleDownload() {
      // 验证时间范围必填
      if (!this.dateTime || this.dateTime.length !== 2 || !this.dateTime[0] || !this.dateTime[1]) {
        this.$message.warning('请选择时间范围')
        return
      }
      let params = JSON.parse(JSON.stringify(this.query))
      params.startTime = this.dateTime[0]
      params.endTime = this.dateTime[1]
      return this.$common.confirm('是否确认导出')
        .then(() => customerRegistrationApi.registrationGiftExport(filterEmpty(params))).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)
          }
        })
    },
  }
}
</script>

<style>
</style>

